import React from 'react';
import './ActionsCard.scss';
import { connect } from 'react-redux';
import { IStoreState, IUserDetails } from '../../types';
import {
  Claims,
  getBasePath,
  isAccountManager,
  isAdmin,
} from '../../helpers/Users/UserHelper';
import { Button } from '@orderly/morrisons-component-library';
import { navigateTo } from '../../routing/Navigation';

interface IActionsCardProps {
  userDetails?: IUserDetails;
}

const ActionsCard = ({ userDetails }: IActionsCardProps) => {
  const roleName = Claims[userDetails.claims[0]];

  return (
    <div className="actions card">
      <h4>{roleName} Actions</h4>
      <p>Quick access to {roleName.toLowerCase()} related activities</p>
      {isAdmin(userDetails) ? (
        <Button
          type="button"
          className="link"
          text="Banners"
          onClick={() => navigateTo('/admin/manage-banners')}
        />
      ) : null}
      {isAdmin(userDetails) ? (
        <Button
          type="button"
          className="link"
          text="Printshop"
          onClick={() => navigateTo('/admin/printshop')}
        />
      ) : null}
      {isAdmin(userDetails) ? (
        <Button
          type="button"
          className="link"
          text="Manage Transport Costs"
          onClick={() => navigateTo('/admin/transport-costs')}
        />
      ) : null}
      {isAdmin(userDetails) || isAccountManager(userDetails) ? (
        <Button
          type="button"
          className="link"
          text="Review Orders"
          onClick={() => navigateTo(`${getBasePath(userDetails)}orders`)}
        />
      ) : null}
      {isAdmin(userDetails) || isAccountManager(userDetails) ? (
        <>
          <Button
            type="button"
            className="link"
            text="Review Claims"
            onClick={() => navigateTo(`${getBasePath(userDetails)}order-claims-review`)}
          />
          <Button
            type="button"
            className="link"
            text="Manage Shopping Lists"
            onClick={() => navigateTo(`${getBasePath(userDetails)}manage-shopping-lists`)}
          />
          <Button
            type="button"
            className="link"
            text="Manage Customer Groups"
            onClick={() => navigateTo(`${getBasePath(userDetails)}customer-groups`)}
          />
        </>
      ) : null}
      {isAdmin(userDetails) ? (
        <Button
          type="button"
          className="link"
          text="Presales"
          onClick={() => navigateTo(`${getBasePath(userDetails)}presales-campaigns`)}
        />
      ) : null}
      {isAdmin(userDetails) ? (
        <Button
          type="button"
          className="link"
          text="Manage Trading Packs"
          onClick={() => navigateTo('/admin/trading-packs')}
        />
      ) : null}
      {isAdmin(userDetails) ? (
        <Button
          type="button"
          className="link"
          text="NPS Results"
          onClick={() => navigateTo('/admin/nps-results')}
        />
      ) : null}
    </div>
  );
};

const mapStateToProps = (state: IStoreState) => {
  return {
    userDetails: state.userDetails,
  };
};

export default connect(mapStateToProps)(ActionsCard);
